import { render, staticRenderFns } from "./TransactionItem.vue?vue&type=template&id=3c9aaed4&scoped=true&"
import script from "./TransactionItem.vue?vue&type=script&lang=js&"
export * from "./TransactionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9aaed4",
  null
  
)

export default component.exports